<template>
  <div class="content" style="position: absolute; top: 1.5rem; width: 100%; bottom: 0.8rem;">
    <iframe :src="url" style="width:100%;height: 99%;frameborder=no" frameborder="no" border="0" marginWidth=0
      marginHeight=0></iframe>
  </div>
</template>
<script>
export default {
  data(){
    return{
      url:"/wx_config/index.html"
    }
  },
  mounted(){
    // openWxConfig()
  }
};
</script>
<style lang="scss" scoped>
.content {
  // padding: 0 55px 30px 0;
  // height: 100%;
  // border: 1px solid #f1f1f1;
  overflow: hidden;
  // min-width: 900px;
  position: relative;
  // box-shadow: 0 0 3px #f1f1f1;
}
.weChat {
  padding: 10px 25px;
  background-color: #fff;
}
</style>
